/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GlassesAttributes } from './glassesAttributes';

export interface GetGlassesData {
  type: GetGlassesData.TypeEnum;
  object: GlassesAttributes;
}
export namespace GetGlassesData {
  export type TypeEnum = 'GLASSES';
  export const TypeEnum = {
    Glasses: 'GLASSES' as TypeEnum,
  };
}
